import React from "react";
var __jsx = React.createElement;
import { DateField } from "@/components/date-field";
/** Compact date-range filter chip with optional month-range mode; wraps DateField. */
export function DateRangeFilter(_ref) {
  var label = _ref.label,
    value = _ref.value,
    _onChange = _ref.onChange,
    testId = _ref.testId,
    _ref$displayFormat = _ref.displayFormat,
    displayFormat = _ref$displayFormat === void 0 ? "MMM d, yyyy" : _ref$displayFormat,
    _ref$enableMonthRange = _ref.enableMonthRange,
    enableMonthRange = _ref$enableMonthRange === void 0 ? false : _ref$enableMonthRange;
  return /*#__PURE__*/React.createElement(DateField, {
    type: "range",
    variant: "filter",
    value: value,
    onChange: function onChange(next) {
      return _onChange(next);
    },
    testId: testId,
    label: label,
    placeholder: label,
    displayFormat: displayFormat,
    enableMonthRange: enableMonthRange
  });
}